// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__48bbu","main":"PrivacyPolicy_main__Hc0wq","strong":"PrivacyPolicy_strong__w0RU5","ul":"PrivacyPolicy_ul__3SEzC","ol":"PrivacyPolicy_ol__D3dUW"};